export class CircularRelationshipError extends Error {
    constructor() {
        super('Circular relationship detected');

        Object.setPrototypeOf(this, CircularRelationshipError.prototype);
    }
}
